const formatPrice = number => {
  return new Intl.NumberFormat("es-CL", {
    style: "currency",
    currency: "CLP"
  }).format(number);
};

const formatDate = date =>{
  return date;
}

const formatNumber = number =>{
  return number.toLocaleString('es-CL');
}

export {formatPrice, formatDate, formatNumber} ;
